import { EnrolledSessionDates } from './enrolled-session-dates.model';

/**
 * Enrolled Sessions model
 */
export class EnrolledSessions {
  constructor(
    public id: number,
    public name: string,
    public dateBegin: string,
    public dateEnd: string,
    public description: string,
    public otherInfo: string,
    public dates: EnrolledSessionDates[]
  ) {}
}
